module.exports = __webpack_public_path__ + "static/media/31_A.fcb1618e.jpg";